<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang='stylus'>
#app
  width 100%
  height 100%
  overflow hidden
  // font-family 'Microsoft YaHei' !importants
@media screen and (max-width:1279px)
  .doctor
    video
      width 100% !important
      height auto !important
    .controlBtn
      img
        width 0.9333rem !important
    img
      width 100% !important
    .first,.second,.third,.fourth
      height auto !important
</style>



// WEBPACK FOOTER //
// src/App.vue